import {
  RadialGradientBG,
  type RadialGradientBGProps,
} from '@jouzen/ecom-components/v3/GradientBG';
import { cx } from 'class-variance-authority';
import type { PropsWithChildren } from 'react';

export interface ImageWrapperProps {
  readonly imageGradientBg?: RadialGradientBGProps | undefined;
}

const ImageWrapper = ({
  children,
  imageGradientBg,
}: PropsWithChildren<ImageWrapperProps>) => {
  const className =
    'aspect-square flex w-full items-center justify-center overflow-hidden relative md:rounded-lg lg:rounded-r-none xxl:rounded-r-lg';

  if (imageGradientBg) {
    return (
      <RadialGradientBG
        {...imageGradientBg}
        aria-live="polite"
        className={cx(className, imageGradientBg.className)}
      >
        {children}
      </RadialGradientBG>
    );
  } else {
    return (
      <div aria-live="polite" className={className}>
        {children}
      </div>
    );
  }
};

export default ImageWrapper;
